
export function PriceClean(price) {
    if (typeof price != "string") {
        price = price.toFixed(2).replace(".", ",");
        return price;
    }
    if (typeof price == "string") {
        price = parseFloat(price).toFixed(2).replace(".", ",");
        return price;
    }
    return price;
}